import { observer } from "mobx-react";
import moment from "moment";
import React from "react";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import { useChipFiltersStore } from "../BaseChipComponents/chipUtils";

export const DateRangeChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    const startDate = applicationFiltersStore.startDate;
    const endDate = applicationFiltersStore.endDate;
    const dateRangeLabel = applicationFiltersStore.dateRangeLabel;

    if (!startDate || !endDate) return null;

    const startLabel = moment(startDate).format("MM/DD/YYYY");
    const endLabel = moment(endDate).format("MM/DD/YYYY");
    const labelPrefix = dateRangeLabel ? `${dateRangeLabel} ` : "";

    return (
        <AppliedFilterChip
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={() => {
                applicationFiltersStore.removeDateRange();
            }}
        >
            {labelPrefix}
            {startLabel} - {endLabel}
        </AppliedFilterChip>
    );
});
